import { setParamIfDefined, setParamIfUndefined, toCanonicalUrlString, toRelativeUrl, toUrl } from "../utils.js";
import { getImageCdnForUrlByDomain } from "../detect.js";
export const parse = url => {
  const parsed = toUrl(url);
  const width = Number(parsed.searchParams.get("w")) || undefined;
  const quality = Number(parsed.searchParams.get("q")) || undefined;
  return {
    base: parsed.toString(),
    width,
    quality,
    cdn: "vercel"
  };
};
export const delegateUrl = url => {
  const parsed = toUrl(url);
  const source = parsed.searchParams.get("url");
  if (!source || !source.startsWith("http")) {
    return false;
  }
  const cdn = getImageCdnForUrlByDomain(source);
  if (!cdn) {
    return false;
  }
  return {
    cdn,
    url: source
  };
};
export const generate = _ref => {
  let {
    base,
    width,
    params: {
      quality = 75,
      root = "_vercel"
    } = {}
  } = _ref;
  // If the base is a relative URL, we need to add a dummy host to the URL
  const url = new URL("http://n");
  url.pathname = "/" + root + "/image";
  url.searchParams.set("url", base.toString());
  setParamIfDefined(url, "w", width, false, true);
  setParamIfUndefined(url, "q", quality);
  return toRelativeUrl(url);
};
export const transform = _ref2 => {
  let {
    url,
    width,
    cdn
  } = _ref2;
  // the URL might be relative, so we need to add a dummy host to it
  const parsedUrl = toUrl(url);
  const isNextImage = parsedUrl.pathname.startsWith("/_next/image") || parsedUrl.pathname.startsWith("/_vercel/image");
  const src = isNextImage ? parsedUrl.searchParams.get("url") : url.toString();
  if (!src) {
    return undefined;
  }
  setParamIfDefined(parsedUrl, "w", width, true, true);
  if (isNextImage) {
    return toCanonicalUrlString(parsedUrl);
  }
  return generate({
    base: src,
    width,
    params: {
      root: cdn === "nextjs" ? "_next" : "_vercel"
    }
  });
};